module.exports = __webpack_public_path__ + "img/ethereum.o.5b2a08c1.png";